// frontend/src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";


// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyDv-Y_milWdLx_kUxvTWzkG4F_5WB1Vmjw",
  authDomain: "shield-portal-d501d.firebaseapp.com",
  projectId: "shield-portal-d501d",
  storageBucket: "shield-portal-d501d.firebasestorage.app",
  messagingSenderId: "478066517622",
  appId: "1:478066517622:web:c533e8fc51d905303a6157"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);